export const getPhoneNumber = (unmasked) => {
  if (unmasked) return '551132624647'
  return '+55 (11) 3262-4647'
}
